<template>
  <Modal v-if="showModal" @close="closeModal">
    <div class="p-modal__content__header">
      {{
        $t('pages.CompaniesCustomSurveyAnswerFiles.errorModal.errorCount', {
          value: errors.length,
        })
      }}
    </div>
    <div class="p-box__body">
      <div class="p-table__content">
        <table>
          <thead>
            <tr>
              <th>
                {{ $t('pages.CompaniesCustomSurveyAnswerFiles.errorModal.line') }}
              </th>
              <th>
                {{ $t('pages.CompaniesCustomSurveyAnswerFiles.errorModal.reason') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(error, i) in errors" :key="`error_${i}`">
              <td>
                {{
                  error.lineNumber !== null ?
                    $t('pages.CompaniesCustomSurveyAnswerFiles.errorModal.errorLine', {
                      value: error.lineNumber,
                    }) : $t('pages.CompaniesCustomSurveyAnswerFiles.errorModal.errorFile')
                }}
              </td>
              <td>
                {{ 
                  $t(
                    'pages.CompaniesCustomSurveyAnswerFiles.errorModal.errorMessage',
                    { attr: translateErrorAttr(error.attr),
                      reason: $t(`pages.CompaniesCustomSurveyAnswerFiles.errorModal.errors.${error.reason}`)
                    }
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Modal>
</template>

<script>
import { camelCase } from '../../../modules/string_converter'
import Modal from '../../Modal.vue'

export default {
  name: 'ImportFilesErrorModal',
  components: {
    Modal,
  },
  props: {
    showModal: Boolean,
    errors: Array,
  },
  emits: ['close-modal'],
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
    translateErrorAttr(errorAttr) {
      // q_xxの場合、"Qxx"に変更
      if (errorAttr.match(/^q_\d+$/)) {
        return camelCase(errorAttr).toLocaleUpperCase()
      }
      return this.$t(`pages.CompaniesCustomSurveyAnswerFiles.errorModal.errors.${errorAttr}`)
    }
  },
}
</script>
<style lang="scss" scoped>
.p-box__body {
  height: 400px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 50, .5);
    border-radius: 10px;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, .3);
  }
}
</style>
